// extracted by mini-css-extract-plugin
module.exports = {"text-underline":"common_text-underline__4Vozj","horizontal-menu":"common_horizontal-menu__6xkTQ"};